import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20portrait%2C%20soft%20warm%20natural%20lighting%2C%20flowing%20hair%2C%20creamy%20white%20background%2C%20artistic%20editorial%20photography%2C%20minimal%20aesthetic%2C%20gentle%20expression%2C%20high%20fashion%20portrait%20with%20natural%20makeup%2C%20soft%20focus%20background&width=1600&height=800&seq=hero-mengruoyu&orientation=landscape"
        alt="孟若羽 - 官方粉丝站"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6">
        <span className="inline-block px-4 py-1.5 mb-6 bg-background-50/20 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full border border-background-50/30">
          官方粉丝站
        </span>
        <h1 className="font-heading text-5xl md:text-7xl font-bold text-background-50 mb-4 tracking-wide">
          孟若羽
        </h1>
        <p className="text-background-50/90 text-lg md:text-xl font-light max-w-xl text-center leading-relaxed mb-8">
          用真诚演绎每一个角色，用实力创造无限可能
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/news"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            最新动态
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/40 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-8 text-background-50/60 text-sm">
          <div className="flex items-center gap-2">
            <span className="font-heading text-2xl font-bold text-background-50">500万+</span>
            <span>粉丝关注</span>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="flex items-center gap-2">
            <span className="font-heading text-2xl font-bold text-background-50">30亿+</span>
            <span>剧集播放</span>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="flex items-center gap-2">
            <span className="font-heading text-2xl font-bold text-background-50">15+</span>
            <span>影视作品</span>
          </div>
        </div>
      </div>
    </section>
  );
}